import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate, useLocation} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import AddRole from '../pages/roles/components/AddRole'
import RolesList from '../pages/roles/components/RolesList'
import EditRole from '../pages/roles/components/EditRole'
import AddAdmin from '../pages/admins/components/AddAdmin'
import AdminsList from '../pages/admins/components/AdminsList'
import AddUser from '../pages/users/components/AddUser'
import UsersList from '../pages/users/components/UsersList'
import ChangePassword from '../pages/layout-builder/ChangePassword'
import AddApplication from '../pages/applications/components/AddApplication'
import ApplicationsList from '../pages/applications/components/ApplicationsList'
import EditApplication from '../pages/applications/components/EditApplication'
import ActiveUsersApplicationsList from '../pages/users-applications/components/ActiveUsersApplicationsList'
import InactiveUsersApplicationsList from '../pages/users-applications/components/InactiveUsersApplicationsList'
import ViewApplicationDetails from '../pages/users-applications/components/ViewApplicationDetails'
import { ProfileHeaderWrapper } from '../modules/profile/ProfileHeaderWrapper'
import { permissionCheck } from '../helper-functions/PermissionCheck'
import OwnerUsersList from '../pages/owner-users/components/UsersList'
import ViewOwnerUserDetail from '../pages/owner-users/components/ViewOwnerUserDetail'
import RolesLogs from '../pages/roles/components/RolesLogs'
import RoleLogs from '../pages/roles/components/RoleLogs'
import AllAdminLogs from '../pages/admins/components/AllAdminLogs'
import SingleAdminLog from '../pages/admins/components/SingleAdminLog'
import ApplicationLogs from '../pages/applications/components/ApplicationLogs'
import ApplicationsLogs from '../pages/applications/components/ApplicationsLogs'
import UserApplicationsLogs from '../pages/users-applications/components/UserApplicationsLogs'
import AllUsersLogs from '../pages/users/components/AllUsersLogs'
import SingleUserLog from '../pages/users/components/SingleUserLog'
import {ProjectsList} from '../pages/projects/components/ProjectsList'
import {StarredProjects} from '../pages/projects/components/StarredProjects'
import {ProjectDetail} from '../pages/projects/components/ProjectDetail'
import {SubprojectDetail} from '../pages/projects/components/SubprojectDetail'
import CreateProjectPage from '../pages/projects/components/CreateProjectPage'
import AllProjectsLogs from '../pages/projects/components/AllProjectsLogs'
import SingleProjectLog from '../pages/projects/components/SingleProjectLog'
import AllProjectCategoriesLogs from '../pages/projects/components/AllProjectCategoriesLogs'
import SingleProjectCategoryLog from '../pages/projects/components/SingleProjectCategoryLog'
import AllProjectUrlsLogs from '../pages/projects/components/AllProjectUrlsLogs'
import SingleProjectUrlLog from '../pages/projects/components/SingleProjectUrlLog'
import {Settings} from '../modules/accounts/components/settings/Settings'
import DigitalAssetsPage from '../pages/digital-assets/DigitalAssetsPage'
var user_create,user_update,user_delete,user_view, user_activity_log
var role_create,role_update,role_delete,role_view,role_activity_log
var application_create,application_update,application_delete,application_view,application_activity_log
var user_application_create,user_application_update,user_application_delete,user_application_view,user_application_activity_log
var project_create,project_update,project_delete,project_view,project_activity_log
var subproject_create,subproject_update,subproject_delete,subproject_view,subproject_activity_log
var category_create,category_update,category_delete,category_view,category_activity_log
var subcategory_create,subcategory_update,subcategory_delete,subcategory_view,subcategory_activity_log
var tag_create,tag_update,tag_delete,tag_view,tag_activity_log
var platform_create,platform_update,platform_delete,platform_view,platform_activity_log
var upload_create,upload_update,upload_delete,upload_view,upload_activity_log
var download_create,download_update,download_delete,download_view,download_activity_log
var settings_view,settings_update,settings_activity_log
var url_activity_log
const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
user_create = permissionCheck('user-create');
  user_update = permissionCheck('user-update');
  user_delete = permissionCheck('user-delete');
  user_view = permissionCheck('user-view');
  user_activity_log = permissionCheck('user-activity-log');
  role_create = permissionCheck('role-create');
  role_update = permissionCheck('role-update');
  role_delete = permissionCheck('role-delete');
  role_view = permissionCheck('role-view');
  role_activity_log = permissionCheck('role-activity-log');
  application_create = permissionCheck('application-create');
  application_update = permissionCheck('application-update');
  application_delete = permissionCheck('application-delete');
  application_view = permissionCheck('application-view');
  application_activity_log = permissionCheck('application-activity-log');
  user_application_create = permissionCheck('user-application-create');
  user_application_update = permissionCheck('user-application-update');
  user_application_delete = permissionCheck('user-application-delete');
  user_application_view = permissionCheck('user-application-view');
  user_application_activity_log = permissionCheck('user-application-activity-log');
  project_create = permissionCheck('project-create');
  project_update = permissionCheck('project-update');
  project_delete = permissionCheck('project-delete');
  project_view = permissionCheck('project-view');
  project_activity_log = permissionCheck('project-activity-log');
  subproject_create = permissionCheck('subproject-create');
  subproject_update = permissionCheck('subproject-update');
  subproject_delete = permissionCheck('subproject-delete');
  subproject_view = permissionCheck('subproject-view');
  subproject_activity_log = permissionCheck('subproject-activity-log');
  category_create = permissionCheck('category-create');
  category_update = permissionCheck('category-update');
  category_delete = permissionCheck('category-delete');
  category_view = permissionCheck('category-view');
  category_activity_log = permissionCheck('category-activity-log');
  subcategory_create = permissionCheck('subcategory-create');
  subcategory_update = permissionCheck('subcategory-update');
  subcategory_delete = permissionCheck('subcategory-delete');
  subcategory_view = permissionCheck('subcategory-view');
  subcategory_activity_log = permissionCheck('subcategory-activity-log');
  tag_create = permissionCheck('tag-create');
  tag_update = permissionCheck('tag-update');
  tag_delete = permissionCheck('tag-delete');
  tag_view = permissionCheck('tag-view');
  tag_activity_log = permissionCheck('tag-activity-log');
  platform_create = permissionCheck('platform-create');
  platform_update = permissionCheck('platform-update');
  platform_delete = permissionCheck('platform-delete');
  platform_view = permissionCheck('platform-view');
  platform_activity_log = permissionCheck('platform-activity-log');
  upload_create = permissionCheck('upload-create');
  upload_update = permissionCheck('upload-update');
  upload_delete = permissionCheck('upload-delete');
  upload_view = permissionCheck('upload-view');
  upload_activity_log = permissionCheck('upload-activity-log');
  download_create = permissionCheck('download-create');
  download_update = permissionCheck('download-update');
  download_delete = permissionCheck('download-delete');
  download_view = permissionCheck('download-view');
  download_activity_log = permissionCheck('download-activity-log');
  settings_view = permissionCheck('settings-view');
  settings_update = permissionCheck('settings-update');
  settings_activity_log = permissionCheck('settings-activity-log');
  url_activity_log = permissionCheck('url-activity-log');
  
  const location = useLocation();
  const isProfilePath = location.pathname.includes('/profile');
  const isDigitalAssetsPath = location.pathname.includes('/digital-assets');
  
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Pages */}
        <Route index element={isProfilePath ? <ProfileHeaderWrapper /> : isDigitalAssetsPath ? <DigitalAssetsPage /> : <DashboardWrapper />} />
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='profile' element={<ProfileHeaderWrapper />} />
        {project_view && <Route path='list' element={<ProjectsList />} />}
        {project_create && <Route path='create' element={<CreateProjectPage />} />}
        {project_view && <Route path='starred' element={<StarredProjects />} />}
        {project_view && <Route path='detail/:id' element={<ProjectDetail />} />}
        {project_view && <Route path='subproject/:id' element={<SubprojectDetail />} />}
        {project_activity_log && <Route path='projects-logs' element={<AllProjectsLogs />} />}
        {project_activity_log && <Route path='single-project-log' element={<SingleProjectLog />} />}
        {category_activity_log && <Route path='projectcategories-logs' element={<AllProjectCategoriesLogs />} />}
        {category_activity_log && <Route path='single-projectcategory-log' element={<SingleProjectCategoryLog />} />}
        {url_activity_log && <Route path='project-urls-logs' element={<AllProjectUrlsLogs />} />}
        {url_activity_log && <Route path='single-project-url-log' element={<SingleProjectUrlLog />} />}
        {/* Digital Assets Routes - Upload permissions */}
        {upload_view && <Route path='digital-assets' element={<DigitalAssetsPage />} />}
        {upload_view && <Route path='digital-assets/*' element={<DigitalAssetsPage />} />}
       {
        application_create &&( <Route path="/applications/add-application" element={<AddApplication />} /> )
       }         
       {
        application_view && ( <Route path="/applications/applications-list" element={<ApplicationsList />} />)
       }  
        {
          application_update &&( <Route path="/applications/edit-application" element={<EditApplication />} />)
        }    
        {
          application_activity_log &&( <Route path="/applications/activity-log" element={<ApplicationLogs />} />)
        }    
        {
          application_view &&( <Route path="/applications/applications-logs" element={<ApplicationsLogs />} />)
        }    
        {/* Roles routes - permission protected */}
        {role_view && <Route path="roles-list" element={<RolesList />} />}  
        {role_create && <Route path="add-role" element={<AddRole />} />}   
        {role_update && <Route path="edit-role" element={<EditRole />} />} 
        {role_activity_log && <Route path="logs" element={<RolesLogs />} />}  
        {role_activity_log && <Route path="role-logs" element={<RoleLogs />} />}
        {
          user_application_view && (
            <Route path="/user-applications/active" element={<ActiveUsersApplicationsList />} />
          )
        }   
        {
          user_application_view && (
            <Route path="/user-applications/inactive" element={<InactiveUsersApplicationsList />} /> 
          )
        }
        {
          user_application_view && (
            <Route path="/user-applications/view-application-details" element={<ViewApplicationDetails />} />
          )
        }   
        {
          user_application_view && (
            <Route path="/user-applications/activity-logs" element={<UserApplicationsLogs />} />
          )
        }  
        {
          user_create && (
            <Route path="/admins/add-admin" element={<AddAdmin />} /> 
          )
        }
        {
          user_view &&(
            <Route path="/admins/admins-list" element={<AdminsList />} /> 
          )
        } 
        {
          user_activity_log &&(
            <>
            <Route path="/admins/all-logs" element={<AllAdminLogs/>} /> 
            <Route path="/admins/log" element={<SingleAdminLog/>} /> 
            </>
          )
        }
        {/* Users Module Routes - permission protected */}
        {user_view && <Route path="users-list" element={<UsersList />} />}
        {user_create && <Route path="add-user" element={<AddUser />} />}
        {user_activity_log && <Route path="user-logs" element={<AllUsersLogs />} />}
        {user_activity_log && <Route path="single-user-log" element={<SingleUserLog />} />}
        {
          user_view &&(
            <>
            <Route path="/owner-users/list-users" element={<OwnerUsersList />} />
            <Route path="/owner-users/view-owner-user" element={<ViewOwnerUserDetail/>} />
            </> 
          )
        } 
        {/* Settings Route */}
        {/* {(settings_view || 1) && <Route path='settings/*' element={
          <SuspensedView>
            <Settings />
          </SuspensedView>
        } />} */}
        <Route path='builder' element={<BuilderPageWrapper />} /> 
        <Route path='menu-test' element={<MenuTestPage />} />        
        <Route path="/change-password" element={<ChangePassword />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
